import { render } from "./Invitation.vue?vue&type=template&id=835d15ae&scoped=true"
import script from "./Invitation.vue?vue&type=script&lang=js"
export * from "./Invitation.vue?vue&type=script&lang=js"

import "./Invitation.vue?vue&type=style&index=0&id=835d15ae&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src141758530/src/mavent-project-vuejs-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-835d15ae"]])

export default __exports__